import { Outlet } from 'react-router-dom';
import StudentSidebar from 'src/components/student/Sidebar';
import UserNavbar from 'src/components/ui/UserNavbar';
import { usePageHeaderStore } from 'src/store/pageHeaderStore';

const StudentPageLayout = () => {
  const { title, description, actions } = usePageHeaderStore();

  return (
    <div className="app-layout bg-gray-50">
      <div className="sidebar sticky top-0">
        <StudentSidebar />
      </div>
      <div className="content-area">
        <UserNavbar
          title={title}
          description={description}
          actions={actions}
          className="px-0 py-0 border-0"
        />

        <main className="flex-grow py-6 px-6 overflow-y-auto">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default StudentPageLayout;
